import { render, staticRenderFns } from "./MagazineArticleReadOnly.vue?vue&type=template&id=5e99e43b&"
import script from "./MagazineArticleReadOnly.vue?vue&type=script&lang=js&"
export * from "./MagazineArticleReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./MagazineArticleReadOnly.vue?vue&type=style&index=0&id=5e99e43b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports